import { render } from "./KeywordRankings.vue?vue&type=template&id=1852969d&scoped=true"
import script from "./KeywordRankings.vue?vue&type=script&lang=js"
export * from "./KeywordRankings.vue?vue&type=script&lang=js"

import "./KeywordRankings.vue?vue&type=style&index=0&id=1852969d&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1852969d"]])

export default __exports__